interface updateWinnerLogoNameProps {
  matchElement: HTMLElement;
  score1: string;
  score2: string;
}

/**
 * Funkce pro aktualizaci vzhledu týmu po skončení zápasu.
 * Zvyraznění vítěze zápasu.
 *
 * @param {HTMLElement} matchElement - HTMLElement - zápas, který má být aktualizován.
 *                                     Obashuje HTMLElementy s data atributy: 'data-match-team-logo-1', 'data-match-team-logo-2', 'data-match-team-name-1' a 'data-match-team-name-2'.
 * @param {string} score1 - Skóre prvního týmu.
 * @param {string} score2 - Skóre druhého týmu.
 */
export const updateWinnerLogoName = ({
  matchElement,
  score1,
  score2,
}: updateWinnerLogoNameProps): void => {
  if (!matchElement) return;

  const logo1Element = matchElement.querySelector<HTMLElement>('[data-match-team-logo-1]');
  const logo2Element = matchElement.querySelector<HTMLElement>('[data-match-team-logo-2]');
  const homeTeam = matchElement.querySelector<HTMLElement>('[data-match-team-name-1]');
  const awayTeam = matchElement.querySelector<HTMLElement>('[data-match-team-name-2]');

  if (!logo1Element || !logo2Element || !homeTeam || !awayTeam) return;

  // const winnerTeamLogo =
  //   Number(score1) > Number(score2)
  //     ? logo1Element
  //     : Number(score1) < Number(score2)
  //       ? logo2Element
  //       : null;
  // if (!winnerTeamLogo) return;
  // winnerTeamLogo.classList.add('detail-match-overview-team__name-logo--winner');

  const winner =
    Number(score1) > Number(score2) ? homeTeam : Number(score1) < Number(score2) ? awayTeam : null;

  if (winner) {
    winner.classList.remove(`typography--body1`);
    winner.classList.add(`typography--body1-bold`);
  }
};
